import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, isEqual, warning, isDef, isPlainObject } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import List from './list';
import Button from '../button';
export default {
  name: buildComponentName('Transfer'),
  model: {
    prop: 'targetKeys'
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-transfer'
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    targetKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderItem: {
      type: Function,
      default: undefined
    },
    listStyle: {
      type: Object,
      default: undefined
    },
    titles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    filterOption: {
      type: Function,
      default: null
    },
    searchPlaceholder: {
      type: String,
      default: '请输入搜索内容'
    },
    notFoundContent: {
      type: String,
      default: 'Not Found'
    },
    rowKey: {
      type: [Function, String],
      default: undefined
    },
    lazy: {
      type: [Object, Boolean],
      default: true
    },
    order: {
      type: String,
      default: 'original',
      validator: function validator(val) {
        return ['original', 'push', 'unshift'].indexOf(val) > -1;
      }
    },
    sort: {
      type: String,
      default: 'ltr',
      validator: function validator(val) {
        return ['ltr', 'rtl'].indexOf(val) > -1;
      }
    }
  },
  data: function data() {
    return {
      innerTargetKeys: [],
      leftSelectedKeys: [],
      rightSelectedKeys: []
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    normalizeDataSource: function normalizeDataSource() {
      var dataSource = this.dataSource,
          innerTargetKeys = this.innerTargetKeys,
          rowKey = this.rowKey,
          order = this.order;
      var leftDataSource = [];
      var rightDataSource = [];

      for (var i = 0, l = dataSource.length; i < l; i += 1) {
        var item = dataSource[i];
        var key = item.key;

        if (rowKey) {
          key = isFunction(rowKey) ? rowKey(item) : item[rowKey];
        }

        if (process.env.NODE_ENV !== 'production' && !isDef(key)) {
          warning(false, 'Each record in dataSource of transfer should have a unique `key` prop, or set `rowKey` to an unique primary key');
        }

        item.$$_key = key;
        var tl = innerTargetKeys.length;
        var idx = innerTargetKeys.indexOf(key);

        if (tl > 0 && idx > -1) {
          if (order === 'push' || order === 'unshift') {
            rightDataSource[idx] = item;
          } else {
            rightDataSource.push(item);
          }
        } else {
          leftDataSource.push(item);
        }
      }

      return {
        left: leftDataSource,
        right: rightDataSource
      };
    },
    disabledItemKeys: function disabledItemKeys() {
      var _this$normalizeDataSo = this.normalizeDataSource,
          left = _this$normalizeDataSo.left,
          right = _this$normalizeDataSo.right;
      return [].concat(_toConsumableArray(left), _toConsumableArray(right)).reduce(function (r, v) {
        var nr = r;

        if (v.disabled) {
          nr[v.$$_key] = true;
        }

        return nr;
      }, {});
    },
    listProps: function listProps() {
      var _this = this;

      var filterOption = this.filterOption,
          showSearch = this.showSearch,
          searchPlaceholder = this.searchPlaceholder,
          notFoundContent = this.notFoundContent,
          titles = this.titles,
          normalizeDataSource = this.normalizeDataSource,
          lazy = this.lazy,
          disabled = this.disabled;
      var commonProps = {
        filterOption: filterOption,
        showSearch: showSearch,
        searchPlaceholder: searchPlaceholder,
        notFoundContent: notFoundContent,
        lazy: lazy,
        disabled: disabled
      };
      return ['left', 'right'].reduce(function (r, k) {
        var nr = r;
        nr[k] = _objectSpread({}, commonProps, {
          direction: k,
          title: k === 'left' ? titles[0] : titles[1],
          dataSource: normalizeDataSource[k],
          checkedKeys: _this["".concat(k, "SelectedKeys")]
        });
        return nr;
      }, {});
    },
    operationElement: function operationElement() {
      var renderOperation = this.renderOperation;
      return renderOperation();
    }
  },
  watch: {
    selectedKeys: function selectedKeys(nVal, oVal) {
      if (!isEqual(nVal, oVal)) {
        this.setListSelectedKeys();
      }
    },
    targetKeys: function targetKeys(nVal, oVal) {
      if (!isEqual(nVal, oVal)) {
        this.innerTargetKeys = nVal;
        this.setListSelectedKeys();
      }
    }
  },
  created: function created() {
    this.innerTargetKeys = this.targetKeys;
    this.setListSelectedKeys();
  },
  methods: {
    setListSelectedKeys: function setListSelectedKeys() {
      var selectedKeys = this.selectedKeys,
          innerTargetKeys = this.innerTargetKeys;
      var leftSelectedKeys = [];
      var rightSelectedKeys = [];

      for (var i = 0, l = selectedKeys.length; i < l; i += 1) {
        var key = selectedKeys[i];

        if (innerTargetKeys.length > 0 && innerTargetKeys.indexOf(key) > -1) {
          rightSelectedKeys.push(key);
        } else {
          leftSelectedKeys.push(key);
        }
      }

      this.leftSelectedKeys = leftSelectedKeys;
      this.rightSelectedKeys = rightSelectedKeys;
    },
    handleChange: function handleChange(direction, moveKeys) {
      var innerTargetKeys = this.innerTargetKeys;

      var keys = _toConsumableArray(innerTargetKeys);

      this.$emit('input', keys);
      this.$emit('change', keys, direction, moveKeys);
    },
    handleSelectChange: function handleSelectChange(direction, changedKeys, checked) {
      var leftSelectedKeys = this.leftSelectedKeys,
          rightSelectedKeys = this.rightSelectedKeys;
      this.$emit('select-change', _toConsumableArray(leftSelectedKeys), _toConsumableArray(rightSelectedKeys), direction, _toConsumableArray(changedKeys), checked);
    },
    onSelect: function onSelect(direction, key, checked) {
      var selectedKeys = this["".concat(direction, "SelectedKeys")];

      if (checked) {
        selectedKeys.push(key);
      } else {
        selectedKeys = selectedKeys.filter(function (k) {
          return k !== key;
        });
      }

      this["".concat(direction, "SelectedKeys")] = selectedKeys;
      this.handleSelectChange(direction, [key], checked);
    },
    onSelectAll: function onSelectAll(direction, changedKeys, checked) {
      var selectedKeys = this["".concat(direction, "SelectedKeys")];

      if (checked) {
        var _selectedKeys;

        (_selectedKeys = selectedKeys).push.apply(_selectedKeys, _toConsumableArray(changedKeys));
      } else {
        selectedKeys = selectedKeys.filter(function (key) {
          return changedKeys.indexOf(key) === -1;
        });
      }

      this["".concat(direction, "SelectedKeys")] = selectedKeys;
      this.handleSelectChange(direction, changedKeys, checked);
    },
    onScroll: function onScroll(direction, e) {
      this.$emit('scroll', direction, e);
    },
    onSearchChange: function onSearchChange(direction, val) {
      this.$emit('search-change', direction, val);
    },
    onSearchClear: function onSearchClear(direction) {
      this.$emit('search-clear', direction);
    },
    moveTo: function moveTo(direction) {
      var order = this.order,
          innerTargetKeys = this.innerTargetKeys,
          disabledItemKeys = this.disabledItemKeys,
          handleSelectChange = this.handleSelectChange,
          handleChange = this.handleChange;
      var changeDirection = direction === 'left' ? 'right' : 'left';
      var selectKeys = this["".concat(changeDirection, "SelectedKeys")];
      var moveKeys = selectKeys.filter(function (k) {
        return !(k in disabledItemKeys);
      });
      var nTargetKeys; // 向左移动

      if (direction === 'left') {
        nTargetKeys = innerTargetKeys.filter(function (k) {
          return moveKeys.indexOf(k) === -1;
        });
      } else {
        nTargetKeys = _toConsumableArray(innerTargetKeys);
        moveKeys.forEach(function (k) {
          if (nTargetKeys.indexOf(k) === -1) {
            if (order === 'unshift') {
              nTargetKeys.unshift(k);
            } else {
              nTargetKeys.push(k);
            }
          }
        });
      }

      this.innerTargetKeys = nTargetKeys;
      this["".concat(changeDirection, "SelectedKeys")] = selectKeys.filter(function (k) {
        return k in disabledItemKeys;
      });
      handleSelectChange(changeDirection, moveKeys, false);
      handleChange(direction, moveKeys);
    },
    normalizeOperation: function normalizeOperation(operation) {
      var disabled = false;
      var text = '';

      if (isPlainObject(operation)) {
        disabled = operation.disabled;
        var _operation$text = operation.text;
        text = _operation$text === void 0 ? '' : _operation$text;
      } else if (typeof operation === 'string') {
        text = operation;
      }

      return {
        disabled: disabled,
        text: text
      };
    },
    getValidSelectedKeys: function getValidSelectedKeys(selectedKeys) {
      var dataSource = this.dataSource;
      return selectedKeys.filter(function (key) {
        return dataSource.some(function (item) {
          return key === item.$$_key && !item.disabled;
        });
      });
    },
    renderOperation: function renderOperation() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          sort = this.sort,
          operations = this.operations,
          leftSelectedKeys = this.leftSelectedKeys,
          rightSelectedKeys = this.rightSelectedKeys,
          moveTo = this.moveTo,
          disabled = this.disabled,
          normalizeOperation = this.normalizeOperation,
          getValidSelectedKeys = this.getValidSelectedKeys; // fix issue #175

      var toLeftOp = normalizeOperation(operations[0]);
      var toRightOp = normalizeOperation(operations[1]); // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/292

      var leftDisabled = disabled || toLeftOp.disabled || getValidSelectedKeys(rightSelectedKeys).length === 0;
      var rightDisabled = disabled || toRightOp.disabled || getValidSelectedKeys(leftSelectedKeys).length === 0;
      var opBtns = [h(Button, {
        "attrs": {
          "type": "primary",
          "disabled": leftDisabled,
          "size": "small",
          "icon": "left"
        },
        "on": {
          "click": function click() {
            return moveTo('left');
          }
        }
      }, [toLeftOp.text])];
      var toRightBtn = h(Button, {
        "attrs": {
          "type": "primary",
          "disabled": rightDisabled,
          "size": "small",
          "icon": "right"
        },
        "on": {
          "click": function click() {
            return moveTo('right');
          }
        }
      }, [toRightOp.text]);

      if (sort === 'ltr') {
        opBtns.push(toRightBtn);
      } else {
        opBtns.unshift(toRightBtn);
      }

      return h("div", {
        "class": "".concat(prefixCls, "-operation")
      }, [opBtns]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        $scopedSlots = this.$scopedSlots,
        classes = this.classes,
        listStyle = this.listStyle,
        renderItem = this.renderItem,
        _this$listProps = this.listProps,
        leftProps = _this$listProps.left,
        rightProps = _this$listProps.right,
        operationElement = this.operationElement,
        onSelect = this.onSelect,
        onSelectAll = this.onSelectAll,
        onScroll = this.onScroll,
        onSearchChange = this.onSearchChange,
        onSearchClear = this.onSearchClear;
    var renderItemFn = $scopedSlots.renderItem || renderItem;

    var leftListProps = _objectSpread({}, leftProps, {
      renderContent: renderItemFn,
      scopedSlots: $scopedSlots
    });

    var rightListProps = _objectSpread({}, rightProps, {
      renderContent: renderItemFn
    });

    var on = {
      select: onSelect,
      'select-all': onSelectAll,
      scroll: onScroll,
      'search-change': onSearchChange,
      'search-clear': onSearchClear
    };
    return h("div", {
      "class": classes
    }, [h(List, _mergeJSXProps([{}, {
      style: listStyle,
      props: leftListProps,
      scopedSlots: $scopedSlots,
      on: on
    }]), [h("template", {
      "slot": "notFoundContent"
    }, [$slots.notFoundContent]), h("template", {
      "slot": "footer"
    }, [$slots.leftFooter])]), operationElement, h(List, _mergeJSXProps2([{}, {
      style: listStyle,
      props: rightListProps,
      scopedSlots: $scopedSlots,
      on: on
    }]), [h("template", {
      "slot": "notFoundContent"
    }, [$slots.notFoundContent]), h("template", {
      "slot": "footer"
    }, [$slots.rightFooter])])]);
  }
};